module.exports = __webpack_public_path__ + "img/page_img_0.5d73d76e.png";